import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waProduct } from "@/lib/whatsapp";

const ProductCard = ({ product, index = 0, compact = false }) => (
  <motion.article
    data-testid={`product-card-${product.codigo}`}
    initial={{ y: 30, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, delay: (index % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
    className={`group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-coal transition-colors duration-500 hover:border-silver/40 ${compact ? "w-60 shrink-0 sm:w-64" : ""}`}
  >
    <Link to={`/produto/${product.id}`} data-testid={`product-link-${product.codigo}`} className="relative block aspect-[4/5] overflow-hidden bg-slate2">
      <img
        src={product.imagem}
        alt={`${product.nome} — ${product.marca} | DM Imports`}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 via-transparent to-transparent opacity-60" />
      <span
        data-testid={`product-status-${product.codigo}`}
        className={`absolute left-3 top-3 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] ${
          product.disponibilidade === "pronta_entrega"
            ? "bg-offwhite text-obsidian"
            : "border border-silver/40 bg-obsidian/60 text-silver backdrop-blur-sm"
        }`}
      >
        {product.disponibilidade === "pronta_entrega" ? "Pronta Entrega" : "Encomenda"}
      </span>
    </Link>

    <div className="flex flex-1 flex-col p-4 sm:p-5">
      <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-zinc-500">{product.marca}</p>
      <h3 className="mt-1.5 font-display text-base font-bold uppercase leading-snug text-offwhite sm:text-lg">
        {product.nome}
      </h3>
      <p className="mt-2 text-xs text-zinc-400">
        {[product.subcategoria, product.cor].filter(Boolean).join(" · ")}
      </p>
      <a
        href={waProduct(product.nome, product.codigo)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`product-interest-button-${product.codigo}`}
        className="mt-4 flex items-center justify-center gap-2 rounded-full border border-silver/30 py-3 text-[11px] font-bold uppercase tracking-[0.18em] text-offwhite transition-colors duration-300 hover:border-transparent hover:bg-offwhite hover:text-obsidian"
      >
        <MessageCircle className="h-4 w-4" />
        Tenho Interesse
      </a>
    </div>
  </motion.article>
);

export default ProductCard;
